var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Tile } from '../../common/Tile';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { thousandSeparator, getValuationCapDetail, getTotalPrincipalDetail, } from '../../../utils/utils';
import { TileHeader } from '../../common/TileHeader';
import { AlertDialog } from '../../common/alert-dialog';
import { CreateDebtNoteModal, } from './create-debt-note-modal';
import { DebtNoteListItem } from './debt-note-list-item';
export function DebtTermTile(props) {
    // State
    var _a = React.useState(false), deleteDialogIsOpen = _a[0], setDeleteDialogIsOpen = _a[1];
    var _b = React.useState(false), deleteAlertIsOpen = _b[0], setAlertDialogIsOpen = _b[1];
    var _c = React.useState(false), createDebtNoteModalIsOpen = _c[0], setCreateDebtNoteModalIsOpen = _c[1];
    // Event handlers
    var openDeleteDialog = function () { return setDeleteDialogIsOpen(true); };
    var closeDeleteDialog = function () { return setDeleteDialogIsOpen(false); };
    var openDeleteAlert = function () { return setAlertDialogIsOpen(true); };
    var closeDeleteAlert = function () { return setAlertDialogIsOpen(false); };
    var confirmDelete = function () {
        props.onDeleteConfirm();
        closeDeleteDialog();
    };
    var openCreateDialog = function () { return setCreateDebtNoteModalIsOpen(true); };
    var closeCreateDialog = function () { return setCreateDebtNoteModalIsOpen(false); };
    // Helpers
    var debtNotes = props.debtNotes;
    var sumPrincipals = debtNotes.reduce(function (acc, debtNote) {
        return (acc +
            (debtNote.state === 'ISSUED' || debtNote.state === 'DRAFT'
                ? debtNote.principal
                : 0));
    }, 0);
    function getAvailablePrincipal(totalPrincipal) {
        if (typeof totalPrincipal === 'number') {
            return totalPrincipal - sumPrincipals;
        }
        return null;
    }
    return (_jsxs(Tile, { children: [_jsx(AlertDialog, { isOpen: deleteDialogIsOpen, title: "Delete this convertible term?", content: "This action cannot be undone", onBackdropClick: closeDeleteDialog, buttons: [
                    {
                        label: 'Delete',
                        primary: true,
                        onClick: confirmDelete,
                    },
                    {
                        label: 'Cancel',
                        onClick: closeDeleteDialog,
                    },
                ] }, void 0),
            _jsx(AlertDialog, { isOpen: deleteAlertIsOpen, title: "Term may not be deleted", content: "Convertible terms with convertible notes may not be deleted.", onBackdropClick: closeDeleteAlert, buttons: [
                    {
                        label: 'Close',
                        primary: true,
                        onClick: closeDeleteAlert,
                    },
                ] }, void 0),
            _jsx(CreateDebtNoteModal, { debtTermName: props.name, availablePrincipal: getAvailablePrincipal(props.totalPrincipal), open: createDebtNoteModalIsOpen, onCancel: closeCreateDialog, onConfirm: function (e) {
                    props.onAddClick(e);
                    closeCreateDialog();
                } }, void 0),
            _jsx(TileHeader, __assign({ actions: [
                    { icon: 'edit', onClick: props.onEditClick },
                    {
                        icon: 'delete',
                        onClick: props.debtNotes.length
                            ? openDeleteAlert
                            : openDeleteDialog,
                    },
                ] }, { children: props.name }), void 0),
            _jsxs(List, { children: [_jsx(ListItem, { primary: "Discount", label: thousandSeparator(props.discount) + "%" }, void 0),
                    _jsx(ListItem, { primary: "Valuation Cap", label: getValuationCapDetail(props.valuationCap) }, void 0),
                    _jsx(ListItem, { primary: "Interest", label: thousandSeparator(props.interest) + "%" }, void 0),
                    _jsx(ListItem, { primary: "Maturity Date", label: "" + props.maturityDate }, void 0),
                    _jsx(ListItem, { primary: "Authorized Amount", label: getTotalPrincipalDetail(props.totalPrincipal) }, void 0)] }, void 0),
            _jsx(TileHeader, __assign({ actions: [{ icon: 'add', onClick: openCreateDialog }] }, { children: "Notes" }), void 0),
            _jsx(List, { children: props.debtNotes.map(function (debtNote) { return (_jsx(DebtNoteListItem, { id: debtNote.id, holder: debtNote.holder, state: debtNote.state, principal: debtNote.principal, onClick: debtNote.onClick }, debtNote.id)); }) }, void 0)] }, void 0));
}
//# sourceMappingURL=debt-term-tile.js.map